// @flow
import React from 'react';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import PartnerViewer from 'containers/partner/PartnerViewer';
import { type Match } from 'react-router-dom';
import PartnerCommentsContainer from 'containers/partner/PartnerCommentsContainer';
import PartnerSequencesContainer from 'containers/partner/PartnerSequencesContainer';
import PlainTemplate from 'components/common/PlainTemplate';
import PageTemplate from 'components/base/PageTemplate';

type Props = {
  match: Match,
};

const Partner = ({ match }: Props) => {
  const { username, urlSlug } = match.params;

  return (
    <PageTemplate>
      <header>
        <MainHeadContainer />
        <MainMobileHeadContainer />
      </header>
      <PlainTemplate>
        <PartnerViewer username={username} urlSlug={decodeURI(urlSlug || '')} />
        <PartnerCommentsContainer />
      </PlainTemplate>
      <PartnerSequencesContainer username={username || ''} />
      <MainMobileFooter />
    </PageTemplate>
  );
};

export default Partner;



// WEBPACK FOOTER //
// ./src/pages/Partner.js